import React, { useEffect } from "react";
import { UPLOADS_URL } from "../../config/constants/api";
import { Player } from "react-tuby";
import "react-tuby/css/main.css";

//import default avatar
import { memo } from "react";

function videoPlayer({ data, index }) {
  let url = data?.fileUrl;
  if (index !== null && index !== undefined) {
    url = data.fileUrls
      ? UPLOADS_URL + "/" + data?.fileUrls[index]
      : UPLOADS_URL + "/" + data?.fileUrl;
  } else {
    url = data?.fileUrl ? (data?.fileUrl.startsWith("http") ? data?.fileUrl : UPLOADS_URL + "/" + data?.fileUrl) : null;
  }

  // Get thumbnail/poster image - prioritize video-specific thumbnails
  let posterUrl = null;
  
  // For lectures with multiple videos, use videoThumbnails array (one per video)
  if (index !== null && index !== undefined && data?.videoThumbnails && data?.videoThumbnails[index]) {
    // Video thumbnails array - specific video thumbnail
    posterUrl = data?.videoThumbnails[index]?.startsWith("http") 
      ? data?.videoThumbnails[index] 
      : UPLOADS_URL + "/" + data?.videoThumbnails[index];
  } else if (data?.videoThumbnail) {
    // Single video thumbnail field
    posterUrl = data?.videoThumbnail.startsWith("http") 
      ? data?.videoThumbnail 
      : UPLOADS_URL + "/" + data?.videoThumbnail;
  } else if (data?.thumbnail) {
    // Lecture thumbnail (single image for the lecture) - use this for all videos in the lecture
    posterUrl = data?.thumbnail.startsWith("http") 
      ? data?.thumbnail 
      : UPLOADS_URL + "/" + data?.thumbnail;
  } else if (data?.vidImage) {
    // Video image field
    posterUrl = data?.vidImage.startsWith("http") ? data?.vidImage : UPLOADS_URL + "/" + data?.vidImage;
  } else if (data?.videoThumbnails && data?.videoThumbnails.length > 0) {
    // First thumbnail from array if no index specified
    posterUrl = data?.videoThumbnails[0]?.startsWith("http") 
      ? data?.videoThumbnails[0] 
      : UPLOADS_URL + "/" + data?.videoThumbnails[0];
  }

  if (!url) {
    return <div>No video available</div>;
  }

  return (
    <Player
      pictureInPicture={true}
      keyboardShortcut={{
        pause: true,
        forward: true,
        rewind: true,
        fullScreen: true,
        mute: true,
      }}
      src={[
        {
          quality: "Full HD",
          url: url,
        },
      ]}
      poster={posterUrl}
    >
      {(ref, { onPlay, ...others }) => (
        <video
          ref={ref}
          {...others}
          onPlay={(e) => {
            // The library original event
            onPlay && onPlay(e);
          }}
        />
      )}
    </Player>
  );
}

export default memo(videoPlayer);
